/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ field: NonNullable<unknown>, verb: NonNullable<unknown> }} Home_Pulse_Detail_Fieldchanged1Inputs */

const id_home_pulse_detail_fieldchanged1 = /** @type {(inputs: Home_Pulse_Detail_Fieldchanged1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.field} ${i?.verb}`)
};

const ms_home_pulse_detail_fieldchanged1 = /** @type {(inputs: Home_Pulse_Detail_Fieldchanged1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.field} ${i?.verb}`)
};

const da_home_pulse_detail_fieldchanged1 = /** @type {(inputs: Home_Pulse_Detail_Fieldchanged1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.field} ${i?.verb}`)
};

const de_home_pulse_detail_fieldchanged1 = /** @type {(inputs: Home_Pulse_Detail_Fieldchanged1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.field} ${i?.verb}`)
};

const en_us2_home_pulse_detail_fieldchanged1 = /** @type {(inputs: Home_Pulse_Detail_Fieldchanged1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.field} ${i?.verb}`)
};

const es_es2_home_pulse_detail_fieldchanged1 = /** @type {(inputs: Home_Pulse_Detail_Fieldchanged1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.field} ${i?.verb}`)
};

const es_mx2_home_pulse_detail_fieldchanged1 = /** @type {(inputs: Home_Pulse_Detail_Fieldchanged1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.field} ${i?.verb}`)
};

const fil_home_pulse_detail_fieldchanged1 = /** @type {(inputs: Home_Pulse_Detail_Fieldchanged1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.field} ${i?.verb}`)
};

const fr_home_pulse_detail_fieldchanged1 = /** @type {(inputs: Home_Pulse_Detail_Fieldchanged1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.field} ${i?.verb}`)
};

const it_home_pulse_detail_fieldchanged1 = /** @type {(inputs: Home_Pulse_Detail_Fieldchanged1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.field} ${i?.verb}`)
};

const hu_home_pulse_detail_fieldchanged1 = /** @type {(inputs: Home_Pulse_Detail_Fieldchanged1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.field} ${i?.verb}`)
};

const nl_home_pulse_detail_fieldchanged1 = /** @type {(inputs: Home_Pulse_Detail_Fieldchanged1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.field} ${i?.verb}`)
};

const no_home_pulse_detail_fieldchanged1 = /** @type {(inputs: Home_Pulse_Detail_Fieldchanged1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.field} ${i?.verb}`)
};

const pl_home_pulse_detail_fieldchanged1 = /** @type {(inputs: Home_Pulse_Detail_Fieldchanged1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.field} ${i?.verb}`)
};

const pt_br2_home_pulse_detail_fieldchanged1 = /** @type {(inputs: Home_Pulse_Detail_Fieldchanged1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.field} ${i?.verb}`)
};

const pt_home_pulse_detail_fieldchanged1 = /** @type {(inputs: Home_Pulse_Detail_Fieldchanged1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.field} ${i?.verb}`)
};

const ro_home_pulse_detail_fieldchanged1 = /** @type {(inputs: Home_Pulse_Detail_Fieldchanged1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.field} ${i?.verb}`)
};

const fi_home_pulse_detail_fieldchanged1 = /** @type {(inputs: Home_Pulse_Detail_Fieldchanged1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.field} ${i?.verb}`)
};

const sv_home_pulse_detail_fieldchanged1 = /** @type {(inputs: Home_Pulse_Detail_Fieldchanged1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.field} ${i?.verb}`)
};

const vi_home_pulse_detail_fieldchanged1 = /** @type {(inputs: Home_Pulse_Detail_Fieldchanged1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.field} ${i?.verb}`)
};

const tr_home_pulse_detail_fieldchanged1 = /** @type {(inputs: Home_Pulse_Detail_Fieldchanged1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.field} ${i?.verb}`)
};

const cs_home_pulse_detail_fieldchanged1 = /** @type {(inputs: Home_Pulse_Detail_Fieldchanged1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.field} ${i?.verb}`)
};

const bg_home_pulse_detail_fieldchanged1 = /** @type {(inputs: Home_Pulse_Detail_Fieldchanged1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.field} ${i?.verb}`)
};

const ru_home_pulse_detail_fieldchanged1 = /** @type {(inputs: Home_Pulse_Detail_Fieldchanged1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.field} ${i?.verb}`)
};

const uk_home_pulse_detail_fieldchanged1 = /** @type {(inputs: Home_Pulse_Detail_Fieldchanged1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.field} ${i?.verb}`)
};

const ar_home_pulse_detail_fieldchanged1 = /** @type {(inputs: Home_Pulse_Detail_Fieldchanged1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.field} ${i?.verb}`)
};

const hi_home_pulse_detail_fieldchanged1 = /** @type {(inputs: Home_Pulse_Detail_Fieldchanged1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.field} ${i?.verb}`)
};

const th_home_pulse_detail_fieldchanged1 = /** @type {(inputs: Home_Pulse_Detail_Fieldchanged1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.field} ${i?.verb}`)
};

const ja_home_pulse_detail_fieldchanged1 = /** @type {(inputs: Home_Pulse_Detail_Fieldchanged1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.field} が${i?.verb}`)
};

const zh_cn2_home_pulse_detail_fieldchanged1 = /** @type {(inputs: Home_Pulse_Detail_Fieldchanged1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.field} ${i?.verb}`)
};

const zh_hant1_home_pulse_detail_fieldchanged1 = /** @type {(inputs: Home_Pulse_Detail_Fieldchanged1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.field} ${i?.verb}`)
};

const ko_home_pulse_detail_fieldchanged1 = /** @type {(inputs: Home_Pulse_Detail_Fieldchanged1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.field} ${i?.verb}`)
};

/**
* | output |
* | --- |
* | "{field} {verb}" |
*
* @param {Home_Pulse_Detail_Fieldchanged1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const home_pulse_detail_fieldchanged1 = /** @type {((inputs: Home_Pulse_Detail_Fieldchanged1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Pulse_Detail_Fieldchanged1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_home_pulse_detail_fieldchanged1(inputs)
	if (locale === "ms") return ms_home_pulse_detail_fieldchanged1(inputs)
	if (locale === "da") return da_home_pulse_detail_fieldchanged1(inputs)
	if (locale === "de") return de_home_pulse_detail_fieldchanged1(inputs)
	if (locale === "en-US") return en_us2_home_pulse_detail_fieldchanged1(inputs)
	if (locale === "es-ES") return es_es2_home_pulse_detail_fieldchanged1(inputs)
	if (locale === "es-MX") return es_mx2_home_pulse_detail_fieldchanged1(inputs)
	if (locale === "fil") return fil_home_pulse_detail_fieldchanged1(inputs)
	if (locale === "fr") return fr_home_pulse_detail_fieldchanged1(inputs)
	if (locale === "it") return it_home_pulse_detail_fieldchanged1(inputs)
	if (locale === "hu") return hu_home_pulse_detail_fieldchanged1(inputs)
	if (locale === "nl") return nl_home_pulse_detail_fieldchanged1(inputs)
	if (locale === "no") return no_home_pulse_detail_fieldchanged1(inputs)
	if (locale === "pl") return pl_home_pulse_detail_fieldchanged1(inputs)
	if (locale === "pt-BR") return pt_br2_home_pulse_detail_fieldchanged1(inputs)
	if (locale === "pt") return pt_home_pulse_detail_fieldchanged1(inputs)
	if (locale === "ro") return ro_home_pulse_detail_fieldchanged1(inputs)
	if (locale === "fi") return fi_home_pulse_detail_fieldchanged1(inputs)
	if (locale === "sv") return sv_home_pulse_detail_fieldchanged1(inputs)
	if (locale === "vi") return vi_home_pulse_detail_fieldchanged1(inputs)
	if (locale === "tr") return tr_home_pulse_detail_fieldchanged1(inputs)
	if (locale === "cs") return cs_home_pulse_detail_fieldchanged1(inputs)
	if (locale === "bg") return bg_home_pulse_detail_fieldchanged1(inputs)
	if (locale === "ru") return ru_home_pulse_detail_fieldchanged1(inputs)
	if (locale === "uk") return uk_home_pulse_detail_fieldchanged1(inputs)
	if (locale === "ar") return ar_home_pulse_detail_fieldchanged1(inputs)
	if (locale === "hi") return hi_home_pulse_detail_fieldchanged1(inputs)
	if (locale === "th") return th_home_pulse_detail_fieldchanged1(inputs)
	if (locale === "ja") return ja_home_pulse_detail_fieldchanged1(inputs)
	if (locale === "zh-CN") return zh_cn2_home_pulse_detail_fieldchanged1(inputs)
	if (locale === "zh-Hant") return zh_hant1_home_pulse_detail_fieldchanged1(inputs)
	return ko_home_pulse_detail_fieldchanged1(inputs)
});
export { home_pulse_detail_fieldchanged1 as "home.pulse.detail.fieldChanged" }